import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsBoolean, IsEnum, IsOptional } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { ProficiencyLevel } from '../../../enums'

export class ListProgramCompetenciesQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'Filter by program version ID' })
  @IsUUID()
  @IsOptional()
  programVersionId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by competency ID' })
  @IsUUID()
  @IsOptional()
  competencyId?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Show only key competencies' })
  @IsBoolean()
  @IsOptional()
  isKey?: boolean

  @ApiPropertyOptional({
    enum: ProficiencyLevel,
    description: 'Filter by expected level',
  })
  @IsEnum(ProficiencyLevel)
  @IsOptional()
  expectedLevel?: ProficiencyLevel
}
